module.exports = __webpack_public_path__ + "client/img/office_01.695d8342.png";